import { observable, action, computed } from "mobx";
import { persist } from "mobx-persist";
import UserModel from "./models/UserModel";

export default class UserStore {
  @observable
  users = new UserModel();
}
